package com.eladfinish.bible.contest.constants

import androidx.compose.ui.graphics.Color

object ColorConstants {
    val HIGHLIGHT = Color(0x64C86400)
    val GREEN = Color(0xFF009600)
    val RED = Color(0xFF960000)

    val INDIGO_DARK = Color(0xff1a237e) // onqelos color / onqelosColor

    const val YELLOW = -0x14c5 //color for view to be dragged (value)
    const val ORANGE = -0x6800 //color for view to drop onto on entering (key)
    const val AMBER = -0x3ef9 //color for view to drop onto it (key)

    val GREEN2 = Color(red = 0, green = 120, blue = 0)
    val RED2 = Color(red = 120, green = 0, blue = 0)

    val BLACK = Color.Black
}
